<template>
  <b-dropdown class="float-right d-inline widget-btn" no-caret variant="link" size="lg">
    <template slot="button-content" class="float-right side-padding p-0">
      <i class="fa fa-filter" aria-hidden="true"></i>
    </template>
    <span>Applied Filters:</span>
    <ul class="current-filters">
      <div v-for="filter in filters" :key="filter.filter_id">
          <b-dropdown-item v-for="(value, index) in filter.filter_value" :key="index"><li>{{ value }}</li></b-dropdown-item>
      </div>
    </ul>
  </b-dropdown>
</template>

<script>
export default {
  name: 'FiltersButton',
  props: ['filters']
}
</script>

<style>
  .widget-btn > button {
    padding: 0;
    color: #23282c;
  }
  .widget-btn .dropdown-menu.show {
    padding: 10px 15px;
    cursor: default;
  }
  .widget-btn .dropdown-menu.show ul {
    padding-inline-start: 20px;
    margin-bottom: 0px;
    margin-block-end: 0px;
  }
  .widget-btn .dropdown-menu.show .dropdown-item {
    padding: 5px;
    cursor: default;
  }
  .widget-btn .dropdown-menu.show .dropdown-item {
    background: #fff !important;
  }
</style>

<style scoped>
  .current-filters div:last-child .dropdown-item:last-child {
    border-bottom: 0;
  }
  .current-filters .dropdown-item:last-child {
    border-bottom: 1px solid #c8ced3;
  }
</style>
